// extracted by mini-css-extract-plugin
export default {"propertyInfo":"PropertyInfo_propertyInfo__n+MnB"};